import { Button, Input, Form } from "@telluscompany/design-system";
import { useForm } from "react-hook-form";
import { Filter } from "lucide-react";

import { useLocalization } from "@i18n";
import { cleanEmptyStrings } from "@shared/hooks";

import { AdminComplexFilterData } from "../../schemas";

interface AdminComplexesFilterProps {
  onFilter: (data: Partial<AdminComplexFilterData>) => void;
  onClear: () => void;
  initialFilters?: Partial<AdminComplexFilterData>;
}

export const AdminComplexesFilter = ({
  onFilter,
  onClear,
  initialFilters,
}: AdminComplexesFilterProps) => {
  const { translate } = useLocalization();

  const form = useForm<AdminComplexFilterData>({
    defaultValues: {
      name: initialFilters?.name ?? "",
      fantasyName: initialFilters?.fantasyName ?? "",
      cnpj: initialFilters?.cnpj ?? "",
      responsibleName: initialFilters?.responsibleName ?? "",
    },
  });

  const handleFilter = (data: AdminComplexFilterData) => {
    onFilter(cleanEmptyStrings(data));
  };

  const handleClear = () => {
    form.reset({
      name: "",
      fantasyName: "",
      cnpj: "",
      responsibleName: "",
    });
    onClear();
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(handleFilter)}>
        <div className="flex flex-column gap-5">
          <Input
            control={form.control}
            label={`${translate("admin.complexes.filter.label.name")}:`}
            name="name"
            type="text"
            placeholder={translate(
              "admin.complexes.filter.placeholder.name",
            )}
          />
          <Input
            control={form.control}
            label={`${translate(
              "admin.complexes.filter.label.fantasyName",
            )}:`}
            name="fantasyName"
            type="text"
            placeholder={translate(
              "admin.complexes.filter.placeholder.fantasyName",
            )}
          />
          <Input
            control={form.control}
            label={`${translate("admin.complexes.filter.label.cnpj")}:`}
            name="cnpj"
            type="text"
            placeholder={translate(
              "admin.complexes.filter.placeholder.cnpj",
            )}
          />
          <Input
            control={form.control}
            label={`${translate(
              "admin.complexes.filter.label.responsibleName",
            )}:`}
            name="responsibleName"
            type="text"
            placeholder={translate(
              "admin.complexes.filter.placeholder.responsibleName",
            )}
          />
        </div>
        <div className="flex justify-end mb-4 gap-4">
          <Button type="button" variant="secondary" onClick={handleClear}>
            {translate("admin.complexes.button.clearFilters")}
          </Button>
          <Button type="submit" iconLeft={<Filter fill="currentColor" />}>
            {translate("admin.complexes.button.filter")}
          </Button>
        </div>
      </form>
    </Form>
  );
};
